import img_multiplayerGame from "../../assets/images/projects/img_multiplayerGame.webp";
import project_billboard from "../../assets/images/projects/project_billboard.webp";
import project_duckburger from "../../assets/images/projects/project_duckburger.webp";
import project_LevelEditor from "../../assets/images/projects/project_LevelEditor.webp";
import project1_9lives from "../../assets/images/projects/project1_9lives.webp";
import project2_CluckingChaos from "../../assets/images/projects/project2_CluckingChaos.webp";
import project3_NFTTerrains from "../../assets/images/projects/project3_NFTTerrains.webp";
import project4_RedImpact from "../../assets/images/projects/project4_RedImpact.webp";
import project5_BrunoComedyClub from "../../assets/images/projects/project5_BrunoComedyClub.webp";
import project6_boids from "../../assets/images/projects/project6_boids.webp";
import project7_FileEncryptionDecryption from "../../assets/images/projects/project7_FileEncryptionDecryption.webp";
import project8_EncryptedUDPPackets from "../../assets/images/projects/project8_EncryptedUDPPackets.webp";
import project9_InteractiveMap from "../../assets/images/projects/project9_InteractiveMap.webp";
import project10_Area51 from "../../assets/images/projects/project10_Area51.webp";
import project_bravado from "../../assets/images/projects/project_bravado.webp";
import project_icky from "../../assets/images/projects/project_icky.webp";
import project_microminers from "../../assets/images/projects/project_microminers.webp";

import styles from "../Projects.module.css";

export const multiplayerGame = {
  thumbnail: img_multiplayerGame,
  title: "Multiplayer Networking",
  date: "2025",
  description: `Having a side project allows me to freely explore technology that I
            find interesting. For this project, my goal was to learn about
            procedural animations, Unity's Netcode for GameObjects, game server
            hosting via AWS, and P2P via Steam services.`,
  skills: [
    "Unity",
    "C#",
    "AWS",
    "EC2 Linux",
    "DynamoDB",
    "API Gateway",
    "Lambda Function",
  ],
  links: {
    more: `#`,
  },
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          Having a side project allows me to freely explore technology that I
          find interesting. For this project, my goal was to learn about
          procedural animations, Unity's Netcode for GameObjects, game server
          hosting via AWS, and P2P via Steam services.
        </p>

        <p>
          This video showcases the Steam P2P flow and a few additional features
          of the project, such as procedural animations:
        </p>

        <iframe
          title="Multiplayer Game Video 1"
          src="https://www.youtube.com/embed/mRTUK7P3De0"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

        <iframe
          title="Multiplayer Game Video 2"
          src="https://www.youtube.com/embed/WXMkeQm6k28"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

        <p>
          Before implementing Steam's P2P infrastructure, I explored several
          other networking solutions to expand my knowledge and understanding of
          multiplayer implementation. First, I set up an AWS EC2 Linux server
          and successfully conducted multiplayer tests. While discussing with an
          industry professional, he recommended purchasing a mini PC, installing
          Linux on it, and setting up a game server to gain deeper insight into
          server configuration. I followed this advice and, after
          port-forwarding and setting up a Unity build-to-Linux server pipeline,
          successfully ran another 4-player multiplayer test on the game.
        </p>

        <p>
          Here's a short video (from an older version of the game) showcasing
          the Linux server playtest from another player's perspective:
        </p>

        <iframe
          title="Multiplayer Game Video 3"
          src="https://www.youtube.com/embed/3RajdvxKE58"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const levelEditor = {
  thumbnail: project_LevelEditor,
  title: "React Three Fiber Level Editor",
  date: "2024",
  description: `I developed a level editor for Playmint's Playerchain Demo game, collaborating closely with the art team to create a tool that simplifies level creation. This editor enabled designers to efficiently build and implement new levels used in the game.`,
  skills: ["React", "R3F", "Three.js", "TypeScript", "GitHub Actions"],
  links: {
    github: "https://github.com/playmint/playerchain-demo-level-editor",
  },
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          I developed a level editor for Playmint's Playerchain Demo game,
          collaborating closely with the art team to create a tool that
          simplifies level creation. This editor enabled designers to
          efficiently build and implement new levels used in the game.
        </p>
      </div>
    );
  },
};

export const duckBurger = {
  thumbnail: project_duckburger,
  title: "Duck vs Burger - Fully On-Chain Game in Downstream",
  date: "2024",
  description: `Working at Playmint introduced me to the fascinating world of fully on-chain games. Soon after joining the team, I was tasked with implementing on-chain logic for one of the Downstream minigames, "Duck vs Burger", where two teams competed by placing either a duck or a burger building.`,
  skills: ["Solidity", "JavaScript", "Ethereum", "Web3"],
  links: {
    more: "#",
    github:
      "https://github.com/playmint/ds/tree/main/contracts/src/maps/duck-burger",
  },
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          Working at Playmint introduced me to the fascinating world of fully
          on-chain games. Soon after joining the team, I was tasked with
          implementing on-chain logic for one of the Downstream minigames, "Duck
          vs Burger", where two teams competed by placing either a duck or a
          burger building.
        </p>

        <p>
          Through this experience I learned a programming language called
          Solidity which is specifically designed for developing smart contracts
          on the Ethereum blockchain. This allowed me to understand and
          implement decentralized logic, handle on-chain data efficiently, and
          ensure the integrity of interactions within the game.
        </p>

        <iframe
          title="Duck vs Burger Video 1"
          src="https://www.youtube.com/embed/26xmN1pat3o"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const billboardNetwork = {
  thumbnail: project_billboard,
  title: "Billboard Advertisement Network",
  date: "2023",
  description: `I developed a mod for a popular multiplayer game using Unreal Engine that allows server owners to install billboards displaying paid advertisements in any level. The mod retrieves ad images via an AWS Lambda function and enables server owners to generate income through a partner program I created. In just one month, ads served through the system received over 1.2 million impressions.`,
  skills: [
    "UE4",
    "C++",
    "HTML",
    "JavaScript",
    "AWS",
    "API Gateway",
    "Lambda Function",
    "S3",
    "CloudWatch",
    "CloudFront",
    "Firebase Hosting",
    "Stripe SDK",
  ],
  achievements: {
    impressions: "1M+",
    customers: 34,
  },
  links: {
    more: "#",
  },
};

export const cluckingChaos = {
  thumbnail: project2_CluckingChaos,
  title: "Clucking Chaos - Casual Mobile Game",
  date: "2023",
  description: `Clucking Chaos is a mobile game that was commissioned by a YouTuber called Floky, who was creating a video to see who would create the best Angry Birds parody game out of a few developers that he found through the freelance service, Fiverr.`,
  skills: [
    "Unity",
    "C#",
    "Blender",
    "Adobe Photoshop",
    "Adobe Premiere",
    "Xcode",
    "Audacity",
  ],
  achievements: {
    installs: "5K",
  },
  links: {
    more: "#",
  },
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          Clucking Chaos is a mobile game that was commissioned by a YouTuber
          called Floky, who was creating a video to see who would create the
          best Angry Birds parody game out of a few developers that he found
          through the freelance service, Fiverr.
        </p>

        <p>
          I worked on this game with my development partner at Locus Amoenus. In
          this game, I created the code, and the models, and Serena, my
          development partner created the scenery, and designed the levels. We
          used Unity, as well as other tools such as Blender to make the 3D
          models, Adobe Photoshop, and Adobe Illustrator.
        </p>

        <p>
          Floky kindly allowed us to keep the advertising revenue made from our
          app, so we implemented Google AdMob to display periodic ads to the
          player. Also, since we had less control over where the game is being
          advertised, we saw that it was important to release the game for iOS
          aswell as Android. Doing this allowed me to learn the tools and skills
          required to release a game on the App Store.
        </p>

        <p>Below is our part of Floky's video:</p>

        <iframe
          title="Clucking Chaos Video Review by Floky"
          src="https://www.youtube.com/embed/YQGKeUIp0gQ?start=398"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const brunoComedy = {
  thumbnail: project5_BrunoComedyClub,
  title: "Bruno's Comedy Club - LLM AI Automated Live Comedy",
  date: "2023",
  description: `During the viral explosion of AI technology accessible to the public, I quickly became interested in leveraging this tech in my own projects. Inspired by the AI Seinfeld show created by "Nothing, Forever", I started my own comedy show powered entirely by AI. The idea is that I can stream the show 24/7 while the AI constantly creates brand-new stand-up routines and bits, and performs it live.`,
  skills: ["Unity", "C#", "Blender", "OpenAI API", "LLM", "AI Image Gen"],
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          During the viral explosion of AI technology accessible to the public,
          I quickly became interested in leveraging this tech in my own
          projects. Inspired by the AI Seinfeld show created by "Nothing,
          Forever", I started my own comedy show powered entirely by AI. The
          idea is that I can stream the show 24/7 while the AI constantly
          creates brand-new stand-up routines and bits, and performs it live.
        </p>

        <iframe
          title="Bruno's Comedy Club Showcase Video"
          src="https://www.youtube.com/embed/uDbs5ukC4VA"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

        <p>
          I implemented the AI features by calling OpenAI's APIs. I would send a
          post request containing Bruno's character and personality, and a
          random style of comedy, and I would ask the AI to format the response
          separately with tags such as "/say", and "/laugh [1 - 3]". My program
          would then calculate the response and it would send everything after
          the "/say" tag to Windows text-to-speech to read it out, while Bruno
          visually performs the set by walking around and waving his arms.
        </p>

        <p>
          Another interesting feature is the parody news segment where the AI
          will come up with a random parody news headline, I would then call a
          text to image AI and display the output on the TV next to the
          headline, and Bruno will perform a comedy routine based on the prompt
          of the headline.
        </p>
      </div>
    );
  },
};

export const encryptedPackets = {
  thumbnail: project8_EncryptedUDPPackets,
  title: "Send and Receive Encrypted UDP Packets",
  date: "2023",
  description: `Following up on my interest in cyber security, I decided to learn about sending data through an IP address, and how that data could be protected. Utilizing a similar encryption method I learned before in my file encryption software, I used that to encrypt outgoing packets, and decrypt the incoming packets.`,
  skills: ["C#"],
};

export const nineLives = {
  thumbnail: project1_9lives,
  title: "9Lives - Casual Mobile Game",
  date: "2022",
  description: `9Lives is a mobile game made in Unity. I worked closely with a colleague throughout the development process, where I would focus on technical programming, and my partner was in charge of the art and design.`,
  skills: [
    "Unity",
    "C#",
    "Blender",
    "Adobe Photoshop",
    "Adobe Premiere",
    "TikTok Ads",
    "AppsFlyer",
    "Audacity",
  ],
  achievements: {
    installs: "7K+",
  },
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          9Lives is a mobile game made in Unity. I worked closely with a
          colleague throughout the development process, where I would focus on
          technical programming, and my partner was in charge of the art and
          design.
        </p>

        <p>
          To market the game, we created TikTok ads paid for by our freelance
          work and we managed to achieve over 650,000 impressions, which
          resulted in over 5,000 app installs.
        </p>

        <iframe
          title="9Lives Teaser Trailer"
          src="https://www.youtube.com/embed/D7tr8oGf-qk?controls=1"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const nftTerrains = {
  thumbnail: project3_NFTTerrains,
  title: "NFT Terrains - OpenSea NFT Integration",
  date: "2022",
  description: `NFT Terrains was my final year project at Kingston University. I became passionate about learning how Minecraft world generation works, which lead me into doing a lot of research into this. I decided to give it a go on my own using Unity.`,
  skills: ["Unity", "C#", "OpenSea", "API", "Web3", "NFT"],
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          NFT Terrains was my final year project at Kingston University. I
          became passionate about learning how Minecraft world generation works,
          which lead me into doing a lot of research into this. I decided to
          give it a go on my own using Unity.
        </p>

        <p>
          It was important that everything had to be created without Unity's
          default features like the lighting, and primitive objects, because if
          I were to use these, the game would become extremely laggy.
        </p>

        <p>
          I really enjoyed the challenges that came with this project such as
          the programatic seed-based random world generation, creating the
          custom shaders, multi-threading, and NFT integration.{" "}
        </p>

        <p>Below is a showcase of the project: </p>

        <iframe
          title="NFT Terrains Showcase Video"
          src="https://www.youtube.com/embed/mJESgzPAXyg"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const redImpact = {
  thumbnail: project4_RedImpact,
  title: "Red Impact - Multiplayer Sci-Fi Shooter",
  date: "2021",
  description: `Red Impact is a multiplayer game I made using Unity. It's a momentum-based Sci-Fi shooter game that has multiple game modes including Deathmatch, and King of The Hill.`,
  skills: ["Unity", "C#", "Photon Bolt", "Blender", "Adobe Photoshop"],
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          Red Impact is a multiplayer game I made using Unity. It's a
          momentum-based Sci-Fi shooter game that has multiple game modes
          including Deathmatch, and King of The Hill.
        </p>

        <p>
          For multiplayer implementation, I used a service called Photon Bolt
          which gave me full control to create fully synced worlds and gameplay.
        </p>

        <p>Here is some footage from a play test with a few players:</p>

        <iframe
          title="RED IMPACT Multiplayer Playtest 1"
          src="https://www.youtube.com/embed/FvbsBp9HVAc"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

        <iframe
          title="RED IMPACT Multiplayer Playtest 2"
          src="https://www.youtube.com/embed/vhYKXVW27WM"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

        <p>
          Before I had decided to turn this into a multiplayer game, this was a
          single-player game with a subtle storyline. Here is a video that shows
          the gameplay that I submitted as one of my University projects:
        </p>

        <iframe
          title="RED IMPACT Story Playthrough"
          src="https://www.youtube.com/embed/pldrBgg9kbU"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const boids = {
  thumbnail: project6_boids,
  title: "Flocking Algorithm - C++ Boids Simulation",
  date: "2020",
  description: `For a university assignment, we were given the task to develop AI with a form of obstacle avoidance using the GFC engine (Kingston University in-house C++ engine). I was intrigued by the flocking algorithm and "boids" which refers to the way in which fish and birds are able to navigate as a flock and not collide with one another.`,
  skills: ["C++"],
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          For a university assignment, we were given the task to develop AI with
          a form of obstacle avoidance using the GFC engine (Kingston University
          in-house C++ engine). I was intrigued by the flocking algorithm and
          "boids" which refers to the way in which fish and birds are able to
          navigate as a flock and not collide with one another.
        </p>

        <iframe
          title="Flocking Algorithm Demo Video"
          src="https://www.youtube.com/embed/KeTH6eAwaOs"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const area51 = {
  thumbnail: project10_Area51,
  title: "Area 51 - Published Game on Steam",
  date: "2019",
  description: `During my journey learning Unity game development. I often published my finished projects on Steam. I made Area 51 in light of a viral internet joke where it was said that a bunch of people would raid the Area 51 military base, so this game is themed around that event.`,
  skills: ["Unity", "C#", "Blender", "Adobe Photoshop", "Adobe Premiere"],
  achievements: {
    sales: "750",
  },
  links: {
    steam: "https://store.steampowered.com/app/1125130/Area_51/",
  },
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          During my journey learning Unity game development. I often published
          my finished projects on Steam. I made Area 51 in light of a viral
          internet joke where it was said that a bunch of people would raid the
          Area 51 military base, so this game is themed around that event.
        </p>

        <p>This is the trailer I made for the game:</p>

        <iframe
          title="AREA 51 Trailer"
          src="https://www.youtube.com/embed/Ou0GhveiG9w"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const cyberSec = {
  thumbnail: project7_FileEncryptionDecryption,
  title: "File Encryption/Decryption",
  date: "2019",
  description: `I became intrigued in the topic of cyber security, so I decided to make a tool that can encrypt and decrypt files by changing each byte of the file to a UNICODE value that is offset by the user-provided key. It could then decrypt the file using the same key and doing the calculation backwards.`,
  skills: ["C#"],
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          I became intrigued in the topic of cyber security, so I decided to
          make a tool that can encrypt and decrypt files by changing each byte
          of the file to a UNICODE value that is offset by the user-provided
          key. It could then decrypt the file using the same key and doing the
          calculation backwards.
        </p>

        <iframe
          title="File Encryption and Decryption Video"
          src="https://www.youtube.com/embed/iJMP7aAPiOQ"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const interactiveMap = {
  thumbnail: project9_InteractiveMap,
  title: "Interactive Map of Banks in Kingston",
  date: "2018",
  description: `For a college assignment, we were given the task to create interactive media that would aid the public. I chose to create an interactive map that shows the locations of all the banks in Kingston, London. I created this using Unity and it was designed to be used on a touch screen kiosk.`,
  skills: ["Unity", "C#", "Blender"],
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          For a college assignment, we were given the task to create interactive
          media that would aid the public. I chose to create an interactive map
          that shows the locations of all the banks in Kingston, London. I
          created this using Unity and it was designed to be used on a touch
          screen kiosk.
        </p>

        <iframe
          title="File Encryption and Decryption Video"
          src="https://www.youtube.com/embed/7x6SFN3nXVQ"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

        <p>
          Using Blender, I animated a scene that displays how the map would look
          on a kiosk.
        </p>

        <iframe
          title="File Encryption and Decryption Video"
          src="https://www.youtube.com/embed/QV84Xmq5WKE"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const bravado = {
  thumbnail: project_bravado,
  title: "Bravado - Published Game on Steam",
  date: "2018",
  description: `I wanted to learn how to make 3D games, so I created 'Bravado', a 3rd person melee slasher.`,
  skills: ["Unity", "C#", "Blender", "Adobe Photoshop", "Adobe Premiere"],
  achievements: {
    sales: "1.5K",
  },
  links: {
    steam: "https://store.steampowered.com/app/966370/Bravado/",
  },
  content: () => {
    return (
      <div className={styles.content}>
        <p>
          I wanted to learn how to make 3D games, so I created 'Bravado', a 3rd
          person melee slasher.
        </p>

        <p>
          After I released my game on Steam, it picked up the attention of the
          'GameGrumps' who made a YouTube video on it which was viewed by over
          450k people:
        </p>

        <iframe
          title="GameGrumps Bravado Video"
          src="https://www.youtube.com/embed/da3zsfnYw8M"
          loading="lazy"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  },
};

export const icky = {
  thumbnail: project_icky,
  title: "Icky - Published Game on Steam",
  date: "2017",
  description: `Inspired by an arcade style 2D platformer game called 'Super Crate Box', I created Icky.`,
  skills: ["Unity", "C#", "Adobe Photoshop", "Adobe Premiere"],
  achievements: {
    sales: "7K",
  },
  links: {
    steam: "https://store.steampowered.com/app/791160/Icky/",
  },
};

export const microMiners = {
  thumbnail: project_microminers,
  title: "Micro Miners - Published Game on Steam",
  date: "2017",
  description: `While learning programming, I thought making a game would be a great and fun way to learn, so I created an idle game called 'Micro Miners'.`,
  skills: ["Unity", "C#", "Adobe Photoshop", "Adobe Premiere"],
  achievements: {
    sales: "4.6K",
  },
  links: {
    more: "#",
    steam: "https://store.steampowered.com/app/730120/Micro_Miners/",
  },
};
